"use strict";

export const _encodeURI = encodeURI